<template lang="pug">
.section
  .section-header
    h1 {{ $t("ui.theme") }}
  .section-body
    .row
      .col-12
        .card.mb-0
          .card-header
            .row.col-12
              .form-group.col-3
                b-input-group(size="sm")
                  b-input-group-text(slot="prepend")
                    i.fas.fa-layer-group
                  ThemeProviderTypeLookup(
                    ref="providerType"
                    size="sm"
                    required
                    type="array"
                    :disabled="loading"
                    haveAll=true
                    v-model="providerType"
                  )

              .form-group.col-6.mb-1
                SubmitButton(
                  :loading="loading"
                  icon="fa fa-search"
                  :text="$t('ui.search')"
                  type="button"
                  @click="getThemeList(true)"
                  variant="primary"
                  size="sm"
                )
              .form-group.col-12(v-if="isAdmin && isEditAccess")
                b-button(v-b-modal.addTheme type="button" variant="info" size="sm")
                  i.fa.fa-plus
                  span.ml-1 {{ $t("ui.combine.add_theme") }}
          .card-body
            .row
              .col-10.mb-1
                b-pagination.float-left(
                  size="sm"
                  hide-ellipsis
                  :total-rows="totalRow"
                  :per-page="getPageSize"
                  v-model="currentPage"
                  @input="changedPage($event)")
              .col-2.mb-1
                b-input-group(:prepend="$t('ui.page_size')" size="sm")
                  b-form-select(:options="$store.getters.pageSizeOptions" :value="getPageSize" @input="changedPageSize" size="sm")
              .col-12
                .clusterize-scroll.table-responsive
                  table.table.table-sm.table-bordered.table-striped.table-hover
                    thead.thead-light
                      tr
                        th.text-center(width="3%")
                          span #
                        th(width="8%")
                          span(:title="$t('ui.theme_provider')") {{ $t('ui.theme_provider') }}
                        th(width="18%")
                          span(:title="$t('ui.theme_code')") {{ $t('ui.theme_code') }}
                        th(width="18%")
                          span(:title="$t('ui.theme_name')") {{ $t('ui.theme_name') }}
                        th.text-center(width="5%")
                          span(:title="$t('ui.status')") {{ $t('ui.status') }}
                        th.text-center(width="5%")
                          span(:title="$t('ui.action')") {{ $t('ui.action') }}
                    tbody.clusterize-content
                      tr(v-if="themeList.length == 0")
                        td(colspan="7").text-center
                          span {{ $t('message.no_data_available') }}
                      tr(v-for="(item, index) in themeList")
                        td.text-center
                          span(:title="index + 1") {{ index + 1 }}
                        td
                          span(:title="item.provider_type") {{ item.provider_type }}
                        td
                          span(:title="item.theme_code") {{ item.theme_code }}
                        td
                          span(:title="item.theme_name") {{ item.theme_name }}
                        td.text-center
                          span
                            i(style="font-size: 14px;" :class="{'fas fa-check-circle text-success': item.enable, 'fas fa-times-circle text-warning': !item.enable  }")
                        td.actions.text-center.align-middle
                          span.mr-2
                            a.fas.fa-palette.btn.btn-ssm.btn-icon.btn-info(
                              href="javascript:void(0)"
                              @click="showThemeColor(item)"
                              :title="$t('ui.color')"
                              )
                          span.mr-2
                            a.fas.fa-book-open.btn.btn-ssm.btn-icon.btn-info(
                              href="javascript:void(0)"
                              @click="showThemeContent(item)"
                              :title="$t('ui.content')"
                              )
                          span.mr-2
                            a.fa.fa-edit.btn.btn-ssm.btn-icon.btn-primary(
                              v-if="isAdmin && isEditAccess"
                              href="javascript:void(0)"
                              @click="onEdit(item)"
                              :title="$t('ui.edit')"
                              )
                          span
                            a.fa.fa-trash.btn.btn-ssm.btn-icon.btn-danger(
                              v-if="isAdmin && isEditAccess"
                              href="javascript:void(0)"
                              @click="onDelete(item)"
                              :title="$t('ui.delete')"
                              )

      addtheme(@clicked="addTheme" @failed="handleFailed")
      edittheme(ref="edittheme" :item="editSelectedTheme" @clicked="afterEdit" @failed="handleFailed")
      themecolor(ref="themeColor" :item="editSelectedTheme")
      themecontent(ref="themeContent" :item="editSelectedTheme")
</template>

<script>
import config from "@/config";
import errorTags from "@/errorTags";
import addtheme from "@/components/content/theme/addTheme.vue";
import edittheme from "@/components/content/theme/editTheme.vue";
import themecolor from "@/components/content/theme/themeColor.vue";
import themecontent from "@/components/content/theme/themeContent.vue";
import SubmitButton from "@/library/SubmitButton.vue";
import DebounceInput from "@/library/DebounceInput";
import ThemeProviderTypeLookup from "@/library/ThemeProviderTypeLookup.vue";

export default {
  components: {
    SubmitButton,
    DebounceInput,
    addtheme,
    edittheme,
    themecolor,
    themecontent,
    ThemeProviderTypeLookup
  },
  data: () => ({
    loading: false,
    editSelectedTheme: null,
    themeList: [],
    providerType: "",
    currentPage: 1,
    totalRow: 0,
    feedback: {
      success: false,
      status: errorTags.request.failed
    },
  }),
  computed: {
    getPageSize() {
      return this.$store.getters.pageSize;
    },
    accountType() {
      return this.$store.getters.accountType;
    },
    isAdmin() {
      return this.$store.getters.accountType === 5;
    },
    isAdminMaster() {
      return [3,5].includes(this.$store.getters.accountType);
    },
    isEditAccess() {
      return this.$helpers.showActionButton("e_theme");
    }
  },
  mounted: function() {
    this.getThemeList(true);
  },
  methods: {
    changedPageSize: function(pageSize) {
      this.$store.dispatch("layout/setPageSize", pageSize);
      this.currentPage = 1;
      this.getThemeList(true);
    },
    changedPage: function(pageNo) {
      this.currentPage = pageNo;
      this.getThemeList();
    },
    onEdit(e) {
      this.editSelectedTheme = e;
      this.$refs.edittheme.$refs.editTheme.show();
    },
    afterEdit() {
      this.getThemeList();
      this.$helpers.showDialog(this.$t("ui.combine.edit_theme"), this.$t("message.success"), "success");
    },
    onDelete:function(e) {
      this.$helpers
        .alert({
          title: this.$t("ui.delete"),
          text: this.$t("message.delete_theme_confirm", { theme: e.provider_type + ' - ' + e.theme_code }),
          type: "question",
          showCancelButton: true
        })
        .then(result => {
          if (result.value) {
            this.confirmDelete(e);
          }
        });
    },
    confirmDelete: function(e) {
      let url = config.deleteThemeUrl();

      var json = {
        auth_token: this.$store.getters.sessionToken,
        action_by: this.$store.getters.loginId,
        theme_code: e.theme_code,
      };

      this.feedback.success = true;
      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              if (typeof response.data.status == "string") {
                this.feedback.success = response.data.status == "1";
              } else {
                this.feedback.success = response.data.status == 1;
              }
              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                // item.status = status;
                this.getThemeList(true);
                this.$helpers.showDialog(this.$t("ui.delete"), this.$t("message.success"), "success");
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    getThemeList: function(isSearch) {
      let url = config.getThemeListUrl();

      if (isSearch) this.currentPage = 1;

      var json = {
        auth_token: this.$store.getters.sessionToken,
        action_by: this.$store.getters.loginId,
        page_number: this.currentPage,
        page_size: this.getPageSize,
        provider_type: this.providerType
      }

      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;

              if (this.feedback.success == true) {
                this.themeList = response.data.dt;
                this.totalRow = this.themeList.length > 0 ? this.themeList[0].totalrows : 0;
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },

    addTheme: function() {
      this.getThemeList(true);
      this.$helpers.showDialog(this.$t("ui.combine.add_theme"), this.$t("message.success"), "success");
    },
    showThemeColor(e) {
      this.editSelectedTheme = e;
      this.$refs.themeColor.$refs.themeColor.show();
    },
    showThemeContent(e) {
      this.editSelectedTheme = e;
      this.$refs.themeContent.$refs.themeContent.show();
    },
    handleFailed: function(tag, status) {
      this.$helpers.showDialog(this.$t("ui.combine." + tag), this.$t("error." + status), "error");
    }
  }
};
</script>